import { useState } from 'react'
import { Tabs } from '@heroui/react'
import { tabOf, type SignageTab } from '../lib/signageEdit'
import type { StaffKey } from '../lib/staffText'
import type { Identity } from '../lib/types'
import { Chrome } from '../ui/Chrome'
import { useStaffText } from '../ui/StaffText'
import { CampaignsTab } from './signageCampaigns'
import { LibraryTab } from './signageLibrary'
import { PlaylistsTab } from './signagePlaylists'
import '../styles/signage.css'

const TABS: ReadonlyArray<[SignageTab, StaffKey]> = [
  ['library', 'signage.tab.library'],
  ['playlists', 'signage.tab.playlists'],
  ['campaigns', 'signage.tab.campaigns'],
]

/** Signage: the shared library, playlists and campaigns, for whoever holds signage.manage. */
export function Signage({ identity, onNavigate }: { identity: Identity; onNavigate: (to: string) => void }) {
  const { say } = useStaffText()
  const [tab, setTab] = useState<SignageTab>(() => tabOf(window.location.hash))
  const choose = (next: SignageTab) => {
    setTab(next)
    window.history.replaceState(null, '', `#${next}`)
  }
  return (
    <Chrome title={say('signage.title')} staff={identity.staff} onNavigate={onNavigate} setup>
      <main className="page signage-page">
        <header className="page__head signage-head">
          <h1 className="page__title">{say('signage.title')}</h1>
          <Tabs selectedKey={tab} onSelectionChange={(key) => choose(tabOf(String(key)))}>
            <Tabs.ListContainer>
              <Tabs.List aria-label={say('signage.title')}>
                {TABS.map(([value, label]) => (
                  <Tabs.Tab key={value} id={value}>
                    {say(label)}
                    <Tabs.Indicator />
                  </Tabs.Tab>
                ))}
              </Tabs.List>
            </Tabs.ListContainer>
          </Tabs>
        </header>
        {tab === 'library' && <LibraryTab />}
        {tab === 'playlists' && <PlaylistsTab />}
        {tab === 'campaigns' && <CampaignsTab />}
      </main>
    </Chrome>
  )
}
